import "./Loader.scss";
const Loader = () => {
    return (
        <div className="loading-bg">
            <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    );
};

export default Loader;
